module.exports = __webpack_public_path__ + "static/dorlands_tree_logo-20f1cf012c0a147b747c23c80cfee5ad.png";